var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShoppingBasket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_117_6135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6605 7.80344L12.6094 10.3048H14.4494C14.5424 10.3012 14.6342 10.3263 14.7124 10.3768C14.7905 10.4273 14.8512 10.5008 14.886 10.5871C14.9208 10.6734 14.9282 10.7683 14.907 10.8589C14.8859 10.9496 14.8372 11.0314 14.7678 11.0933L13.1699 12.2088L14.0549 14.2455C14.0937 14.3387 14.1024 14.4416 14.0796 14.54C14.0569 14.6382 14.0039 14.727 13.9282 14.7936C13.8524 14.8602 13.7576 14.9014 13.6572 14.9113C13.5568 14.9213 13.4558 14.8995 13.3684 14.849L11.2266 13.6438L9.08781 14.849C9.00042 14.8995 8.89944 14.9213 8.79902 14.9113C8.6986 14.9014 8.60383 14.8602 8.52805 14.7936C8.45227 14.727 8.3993 14.6382 8.37656 14.54C8.35382 14.4416 8.36248 14.3387 8.40133 14.2455L9.28632 12.2088L7.68841 11.0933C7.61878 11.0317 7.56992 10.95 7.54853 10.8595C7.52708 10.7691 7.53415 10.6742 7.56875 10.5879C7.60329 10.5015 7.6637 10.428 7.74169 10.3773C7.81968 10.3267 7.91138 10.3014 8.0043 10.3048H9.84805L10.7951 7.80344C10.8364 7.72435 10.8985 7.65809 10.9748 7.61188C11.0511 7.5656 11.1386 7.54114 11.2278 7.54114C11.317 7.54114 11.4045 7.5656 11.4808 7.61188C11.5571 7.65809 11.6192 7.72435 11.6605 7.80344Z",
    stroke: "#585858",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.46482 11.2266H3.27629C3.07668 11.2229 2.88415 11.152 2.72988 11.0253C2.57561 10.8986 2.46865 10.7235 2.42632 10.5284L1.11234 4.99715C1.07716 4.86467 1.07229 4.72598 1.09809 4.59137C1.1239 4.45676 1.17971 4.32969 1.26138 4.21961C1.34304 4.10954 1.44847 4.01929 1.56982 3.95557C1.69117 3.89185 1.82532 3.8563 1.96231 3.85156H13.1158C13.2527 3.85641 13.3868 3.89204 13.5081 3.95579C13.6294 4.01955 13.7348 4.10979 13.8164 4.21983C13.8981 4.32988 13.9539 4.4569 13.9797 4.59146C14.0056 4.72602 14.0008 4.86468 13.9657 4.99715L13.7814 5.76906",
    stroke: "#585858",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.92969 3.85156L5.69531 1.08594",
    stroke: "#585858",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1484 3.85155L9.38281 1.08716",
    stroke: "#585858",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_117_6135"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBasket);
export default __webpack_public_path__ + "static/media/shopping-basket.50f753813295a05b0dabb595a035595f.svg";
export { ForwardRef as ReactComponent };